import React, {FunctionComponent} from "react";
import {GarageBadge} from "@App/Components/GarageBadge";
import {
    BadgeCheckIcon,
    EuroIcon,
    LocationIcon,
    OutlinedCalendarIcon,
    OutlinedStarIcon
} from "@App/Components/common/Icons";
import {useTranslation} from "react-i18next";
import {Garage} from "@App/types";
import {GarageHasNationwideService} from "@App/utils/conditionals/garages";

type GarageListItemBadgeProps = {
    nearest?: boolean
    earliestAvailable?: boolean
    bestReviewed?: boolean
    authorized?: boolean
    cheapest?: boolean
    garage?: Garage
};

export const GarageListItemBadge: FunctionComponent<GarageListItemBadgeProps> = (props: GarageListItemBadgeProps) => {

    const {t} = useTranslation() // i18next

    return (
        <div
            className={'absolute z-10 top-0 left-0 lg:left-auto lg:right-10 flex gap-1'}>
            {props.nearest && (
                <GarageBadge icon={<LocationIcon className={"h-3 w-3 mr-1 fill-white"}/>}
                             name={GarageHasNationwideService(props.garage) ? t('badges.mobileService') : t('badges.smallestDistance')}/>
            )}
            {props.earliestAvailable && (
                <GarageBadge
                    icon={<OutlinedCalendarIcon className={"h-3 w-3 mr-1 fill-white"}/>}
                    name={t('badges.earliestAppointment')}/>
            )}
            {props.bestReviewed && (
                <GarageBadge
                    icon={<OutlinedStarIcon className={"h-3 w-3 mr-1 fill-white"}/>}
                    name={t('badges.bestRating')} hint={t('garageList.badges.best-reviewed-hint')}/>
            )}
            {props.cheapest && (
                <GarageBadge
                    icon={<EuroIcon className={"h-3 w-3 mr-1 fill-white"}/>}
                    name={t('badges.lowestPrice')}/>
            )}
            {props.authorized && (
                <GarageBadge
                    icon={<BadgeCheckIcon className={"h-3 w-3 mr-1 fill-white"}/>}
                    name={t('badges.authorizedGarage')}/>
            )}
        </div>
    );
}


